import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { ConfirmationService } from 'primeng/primeng';

@Component({
    selector: 'app-modal-processos-cliente',
    templateUrl: './modal-processos-cliente.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-processos-cliente.component.css']
})
export class ModalProcessosClienteComponent implements OnInit {

    @Output() processoSetorEvent: EventEmitter<ProcessoSetor[]>;
    @Input() setoresCliente: SetorCliente[];
    @Input() habilitarSelecaoProcessos: boolean;
    public processosSetor: ProcessoSetor[];

    constructor(private modalService: NgbModal,
        private confirmationService: ConfirmationService) {
        this.processoSetorEvent = new EventEmitter<ProcessoSetor[]>();
    }

    cadastrar(content) {
        if (!this.habilitarSelecaoProcessos) {
            this.confirmationService.confirm({
                message: 'Selecione um Setor',
                rejectVisible: false,
                accept: () => {
                },
                reject: () => {
                }
            });
        } else {
            this.processosSetor = new Array<ProcessoSetor>();
            const ngbModalOptions: NgbModalOptions = {
                backdrop: 'static',
                keyboard: false,
                windowClass: 'modalProcesosCliente',
                size: 'lg'
            };
            this.modalService.open(content, ngbModalOptions).result.then((result) => {
                this.processosSetor = result;
                this.processoSetorEvent.emit(this.processosSetor);
            }, (reason) => {
            });
        }
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/modal-processos-cliente/modal-processos-cliente.component.ts